import React, { useMemo } from 'react';
import './styles.scss';
import { SyncOutlined } from '@ant-design/icons';
import cn from 'classnames';
import { FormattedMessage } from "react-intl";

const DangerousLevel = ({
  level,
  redText,
  greenText,
  yellowText,
  blueText,
}) => {
  const PACING_INDICATOR = useMemo(() => {
    return {
      GREEN: greenText || <FormattedMessage id="dangerous_level.normal" />,
      YELLOW: yellowText || <FormattedMessage id="dangerous_level.monitor" />,
      RED: redText || <FormattedMessage id="dangerous_level.at_risk" />,
      OPTIMIZING: blueText || <FormattedMessage id="dangerous_level.optimizing" />,
    };
  }, [greenText, yellowText, redText, blueText]);

  return (
    <div className="dangerous-level w-100p d-flex align-items-center">
      <div
        className={cn('mr-4', {
          [`${level.toLowerCase()}`]: true,
        })}
      >
        {level.toLowerCase() === 'optimizing' && <SyncOutlined />}
      </div>
      <span>{PACING_INDICATOR[level.toUpperCase()]}</span>
    </div>
  );
};

export default DangerousLevel;
